import React, { useEffect, useRef, useState } from 'react';
import { Animated, Easing, Image, ImageBackground, ImageSourcePropType, StyleSheet, TouchableOpacity, TouchableWithoutFeedback, View } from 'react-native';
import Icon from 'react-native-vector-icons/FontAwesome';
import { useDimensions } from 'react-native-web-hooks';
import Game from '../../shell/Game';
import useFontSize from '../../shell/hooks/useFontSize';
import { WaitForLoadImage } from '../../shell/ImageHandler/WaitForLoadImage';
import { useAppSelector } from '../../store/hooks';
import { setAdvance } from '../../store/slices/AdvanceSlice';
import { selectGameObject, TtalkStateINT } from '../../store/slices/gameObjectSlice';
import { PhoneStyle, selectPhone, setPhoneDisplay } from '../../store/slices/phoneSlice';
import { store } from '../../store/store';
import { parseRequire } from '../../utils/parseImageUrl';
import TTalkContainer from '../TTalkContainer';
import { useSkippingLogic } from '../useSkippingLogic';
import { Phone as PhoneClass, PHONE_BUTTONS } from './PhoneClass';
import { PhoneMessages } from './PhoneMessages';

;
interface PhoneProps {

}

export const Phone: React.FC<PhoneProps> = ({ }) => {
    const phoneURL = require("@lss/common/game/assets/Phone/phone2.webp");
    // const img = require("@lss/common/game/assets/Phone/V1JoeShowingPhone_0.webp");
    const [onBackgroundClicked, setOnBackgroundClicked] = useState(false);
    const RightArrow = require("@lss/common/game/assets/ActionButtons/continueBtn.webp");
    const leftArrow = require("@lss/common/game/assets/ActionButtons/returnBtn.webp");
    const x = require("@lss/common/game/assets/ActionButtons/xBtn.webp");
    const [history, setHistory] = useState<TtalkStateINT[]>([]);

    const phoneSlice = useAppSelector(selectPhone);
    const gameObject = useAppSelector(selectGameObject);
    const { width, height } = useDimensions().window;
    const [position, setPosition] = useState<number>(-1);
    const spinValue = useRef(new Animated.Value(0));
    const spinScale = useRef(new Animated.Value(0));
    const spin = useRef(spinValue.current.interpolate({
        inputRange: [0, 1],
        outputRange: ['0deg', '90deg']
    }));
    const scale = useRef(spinScale.current.interpolate({
        inputRange: [0, 1],
        outputRange: ['0%', '100%']
    }));
    const size = useFontSize(15);

    const specialStyles = {
        [PhoneStyle.INSTA]: StyleSheet.create({
            mainPhoneWrapper: {
                position: "absolute",
                left: 0,
                right: 0,
                bottom: 0,
                top: 0,
                aspectRatio: 16 / 9,
            },
            image: {
                position: "absolute",
                aspectRatio: 16 / 9,
                height: "47%",
                transform: [{ rotateZ: "-19.3deg" }],
                alignSelf: "center",
                alignItems: "center",
                left: "19.5%",
                bottom: "34%"

            },

            rightArrow: {
                position: "absolute",
                width: useFontSize(12),
                height: useFontSize(12),
                alignSelf: "center",
                top: "15%",
                transform: [{ rotateZ: "-19.3deg" }],
                left: "75%",
                zIndex: 20

            },
            leftArrow: {
                position: "absolute",
                width: useFontSize(15),
                height: useFontSize(15),
                alignSelf: "center",
                top: "58%",
                transform: [{ rotateZ: "-19.3deg" }],
                right: "88%",

            },
            thumbsUp: {
                position: "absolute",
                width: useFontSize(15),
                height: useFontSize(15),
                right: "25%",
                bottom: "28%",
                transform: [{ rotateZ: "-19.3deg" }],
            },
            thumbsDown: {
                position: "absolute",
                width: useFontSize(15),
                height: useFontSize(15),
                right: "35%",
                bottom: "19%",
                transform: [{ rotateZ: "-19.3deg" }, { scaleX: -1 }],


            }
        })
    };
    const normalStyle = StyleSheet.create({
        container: {
            width: "100%",
            height: "100%"
        },
        mainPhoneWrapper: {
            position: "absolute",
            display: "flex",
            alignSelf: "center",
            flex: 1,
            aspectRatio: 903 / 1200,
            // width: width / 2.7
            height
        },
        phone: {
            position: "absolute",
            height: "100%",
            width: "100%",
            // transform:[{scaleX:-1,scaleY:-1}]

        },
        image: {
            zIndex: -1,
            // height: height - (5 / PixelRatio.get()),
            // top: 2,
            // left: 4,
            position: "absolute",
            height: "96%",
            width: "93%",
            top: "2%",
            left: "3.5%",

            // aspectRatio: 1100 / 1500,
            // width: "96%",
            // borderRadius: 40,
            // borderWidth: 3,
            // borderColor: "red"
        },

        rightArrow: {
            position: "absolute",
            width: useFontSize(12),
            height: useFontSize(12),
            alignSelf: "center",
            top: "30%",
            left: "80%",
            // left: isMobile() ? "79%" : "105%",
            zIndex: 20
            // right: 250 / PixelRatio.get(),

        },
        rightArrowImage: {
            width: "100%",
            height: "100%",


        },
        leftArrow: {
            position: "absolute",
            width: useFontSize(12),
            height: useFontSize(12),
            alignSelf: "center",
            top: "30%",
            right: "80%",
            // right: isMobile() ? "79%" : "105%"
            // left: "15%",
            // left: 250 / PixelRatio.get(),

        },
        leftArrowImage: {

            width: "100%",
            height: "100%",
        },
        x: {
            position: "absolute",
            width: useFontSize(10),
            height: useFontSize(10),
            alignSelf: "center",
            right: 0
            // left: "15%",
            // left: 250 / PixelRatio.get(),

        },
        xImage: {

            width: "100%",
            height: "100%",
        }, talk: {
            width: "100%",
            position: "absolute",
            bottom: "8%",
        },
    });


    // Next, interpolate beginning and end values (in this case 0 and 1)
    const styles = phoneSlice.present.style && ((specialStyles as any)?.[phoneSlice.present.style]) ? { ...normalStyle, ...(specialStyles as any)[phoneSlice.present.style] } : normalStyle;

    useEffect(() => {
        if (Game.rollback && (phoneSlice.present.display || phoneSlice.present.displayMessagesUI)) {
            store.dispatch(setPhoneDisplay({ display: false, displayMessagesUI: false }));
        }

        // setTimeout(() => {
        //     Animated.parallel([
        //         Animated.timing(
        //             spinValue.current,
        //             {
        //                 toValue: 1,
        //                 duration: 500,
        //                 easing: Easing.linear, // Easing is an additional import from react-native
        //                 useNativeDriver: true  // To make use of native driver for performance
        //             }
        //         ),
        //         Animated.timing(
        //             spinScale.current,
        //             {
        //                 toValue: 1,
        //                 duration: 3000,
        //                 easing: Easing.linear, // Easing is an additional import from react-native
        //                 useNativeDriver: true  // To make use of native driver for performance
        //             }
        //         )

        //     ]).start();
        // }, 1);
        // console.log("spin", spin);
        // First set up animation 


    }, [phoneSlice, position]);
    useEffect(() => {
        setOnBackgroundClicked(false);
        if (phoneSlice.present.comment?.options?.wait === false) {
            store.dispatch(setAdvance({ canAdvance: true }));
        }
        if (useSkippingLogic()) {
            store.dispatch(setAdvance({ canAdvance: true, promise: null }));
        }

    }, [phoneSlice.present.comment]);

    const onBackgroundClick = () => {
        store.dispatch(setAdvance({ canAdvance: true }));
        setOnBackgroundClicked(true);
    };

    // function loadImages(images: TimageINT[]) {
    //     return Promise.all(images.map((image) => {
    //         return Image.prefetch(image.url);
    //     }));

    // }

    const onRightClick = async () => {
        PhoneClass.onBtnPressed(PHONE_BUTTONS.RIGHT);

    };
    const onLeftClick = async () => {
        PhoneClass.onBtnPressed(PHONE_BUTTONS.LEFT);

    };
    const onThumbsUpClick = async () => {
        PhoneClass.onBtnPressed(PHONE_BUTTONS.THUMBS_UP);

    };
    const onThumbsDownClick = async () => {
        PhoneClass.onBtnPressed(PHONE_BUTTONS.THUMBS_DOWN);

    };
    const onExit = async () => {

        PhoneClass.onBtnPressed(PHONE_BUTTONS.EXIT);

    };
    /**
     * 
     *     transform: rotate(
            90deg
            ) translateY(-100%);
            transform-origin: top left;
            height:100vw;
            width:100vh;
     */

    return (
        // { transform: [{ rotate: spin.current, }]}
        <>
            {phoneSlice.present.displayMessagesUI ?
                // { transform: [{ translateX: 0}, { rotate: '90deg' }, { translateX: -1 * (width / 5) }], height: width, width: height },
                <>
                    <PhoneMessages mainImageStyle={styles.mainPhoneWrapper} history2={history} phoneStyle={styles.phone} imageStyle={styles.image} phoneImage={parseRequire(phoneURL)}></PhoneMessages>

                    {phoneSlice.present.comment?.text ? <TTalkContainer style={{ position: "absolute", width: "100%", bottom: 0, height: "20%", backgroundColor: "#0000009c" }} talkObject={{ ...phoneSlice.present.comment }}></TTalkContainer> : <></>}
                </>
                : <></>}

            {phoneSlice.present.display ?
                <>

                    <TouchableWithoutFeedback onPress={() => onBackgroundClick()}>
                        <View onTouchStart={() => onBackgroundClick()} style={{
                            height: "100%",
                            width: "100%",
                            aspectRatio: 16 / 9,
                            alignSelf: "center",

                        }}>



                            <ImageBackground source={gameObject.present.image.url as any} style={{ height: "100%", width: "100%" }} resizeMode={"contain"}>
                                <View style={styles.mainPhoneWrapper}>
                                    <WaitForLoadImage style={styles.image} canvasStyle={phoneSlice.present.style === PhoneStyle.INSTA ? undefined : {
                                        width: "min(100%, 100vh * 2 / 3)",
                                        aspectRatio: "2/3"
                                    }} source={phoneSlice.present.image?.url as ImageSourcePropType} resizeMode={"cover"}>
                                    </WaitForLoadImage>
                                    {phoneSlice.present.style === PhoneStyle.NORMAL ? <Image style={styles.phone} source={phoneURL?.default || phoneURL} resizeMode={"cover"}></Image> : <></>}
                                </View>
                                {phoneSlice.present.comment && !onBackgroundClicked ? <TTalkContainer style={{ position: "absolute", width: "100%", bottom: "10%" }} talkObject={{ ...phoneSlice.present.comment }}></TTalkContainer> : <></>}

                            </ImageBackground>

                            {/* BUTTONS */}
                        </View>
                    </TouchableWithoutFeedback>
                    {phoneSlice.present.buttons.includes(PHONE_BUTTONS.EXIT) ?
                        <TouchableOpacity onPress={() => onExit()} style={styles.x}>
                            <Image resizeMode={"cover"} source={x?.default || x} style={styles.xImage} />
                        </TouchableOpacity>
                        : <></>}
                    {phoneSlice.present.buttons.includes(PHONE_BUTTONS.RIGHT) ?
                        <TouchableOpacity onPress={() => onRightClick()} style={styles.rightArrow}>
                            <Image resizeMode={"cover"} source={RightArrow?.default || RightArrow} style={styles.rightArrowImage} />
                        </TouchableOpacity>

                        : <></>}
                    {phoneSlice.present.buttons.includes(PHONE_BUTTONS.LEFT) ?
                        <TouchableOpacity onPress={() => onLeftClick()} style={styles.leftArrow}>
                            <Image resizeMode={"cover"} source={leftArrow?.default || leftArrow} style={styles.leftArrowImage} />
                        </TouchableOpacity>
                        : <></>}
                    {phoneSlice.present.style == PhoneStyle.INSTA ?
                        <>
                            {phoneSlice.present.buttons.includes(PHONE_BUTTONS.THUMBS_UP) ? <TouchableOpacity onPress={() => onThumbsUpClick()} style={styles.thumbsUp}>
                                <Icon name="thumbs-up" color={"#0072ff"} size={size} />

                            </TouchableOpacity> : <></>}
                            {phoneSlice.present.buttons.includes(PHONE_BUTTONS.THUMBS_DOWN) ? <TouchableOpacity onPress={() => onThumbsDownClick()} style={styles.thumbsDown}>
                                <Icon name="thumbs-down" color={"red"} size={size} />

                            </TouchableOpacity> : <></>}
                        </>
                        : <></>}
                </>

                :
                <></>

            }

        </>

    );
};

